import React, { useContext } from 'react';
import { UiContext } from 'uiContext';
import { Box, Typography } from '@mui/material';
import IconDirectSpeed from 'icons/iconDirectSpeed';
import IconReverseSpeed from 'icons/iconReverseSpeed';
import IconDirectSpeedDesktop from 'icons/iconDirectSpeedDesktop';
import IconReverseSpeedDesktop from 'icons/iconReverseSpeedDesktop';

export default function SpeedContainer({
  directSpeed,
  reverseSpeed,
  isMobileIcons,
  isTablet,
}: {
  directSpeed: number;
  reverseSpeed: number;
  isMobileIcons: boolean;
  isTablet?: boolean;
}) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Box
      sx={{
        'display': 'flex',
        'alignItems': 'center',
        'gap': sp.s50,
        '& > *': {
          display: 'flex',
          gap: sp.s20,
          alignItems: 'center',
        },
      }}
    >
      <Box>
        {isMobileIcons ? (
          <IconDirectSpeed></IconDirectSpeed>
        ) : (
          <IconDirectSpeedDesktop
            sizeKey={isTablet ? '14x17' : '16x16'}
          ></IconDirectSpeedDesktop>
        )}
        <Typography variant={isMobileIcons ? 'f16b' : isTablet ? 'f12' : 'f14'}>
          {directSpeed} км/ч
        </Typography>
      </Box>
      <Box>
        {isMobileIcons ? (
          <IconReverseSpeed></IconReverseSpeed>
        ) : (
          <IconReverseSpeedDesktop
            sizeKey={isTablet ? '14x17' : '16x16'}
          ></IconReverseSpeedDesktop>
        )}
        <Typography variant={isMobileIcons ? 'f16b' : isTablet ? 'f12' : 'f14'}>
          {reverseSpeed} км/ч
        </Typography>
      </Box>
    </Box>
  );
}
